module.exports = __webpack_public_path__ + "img/img22.20fc6320.png";